import request from "../../utils/axios";

export const apiGetUserInfo = async () => {
  const res = await request.get({ url: "/member/user/get" });
  return res;
};

export const apiRefreshToken = async (refreshToken) => {
  const res = await request.post({
    url: "/member/auth/refresh-token?refreshToken=" + refreshToken,
  });
  return res;
};

export const apiUpdateUser = async (data) => {
  const res = await request.put({ url: "/member/user/update", data });
  return res;
};

export const apiUpdateUserPwd = async (data) => {
  const res = await request.put({
    url: "/member/user/update-password-nosms",
    data,
  });
  return res;
};

export const apiGetWsInfo = async () => {
  const res = await request.get({ url: "/member/user/test" });
  return res;
};

export const apiUserPage = async (params) => {
  return await request.get({
    url: `/member/user/page`,
    params,
    timeout: 0,
  });
};
